import { ChiptaElement, html } from 'chipta-libs/main.js';

class TicketshopFooter extends ChiptaElement {

  render() {

    return html`

      <footer>
        <a class="powered-by" href="http://www.chipta.com/" target="_blank">
          <span class="powered-by-text">Powered by:</span>
          <img src="/static/ticketshop/img/chipta-logo-small.png"></img>
        </a>
      </footer>

      <style>

        :host {
          display: block;
          margin-bottom: 10px;
        }

        footer {
          max-width: ${_themeData.max_width};
          margin: 75px auto 0 auto;
          text-align: center;
          color: #666;
        }

        .powered-by {
          display: inline-flex;
          justify-content: right;
          align-items: center;
          text-decoration: none;
        }

        .powered-by-text {
          margin-right: 5px;
          font-size: 12px;
          color: #2AABE2;
        }

      </style>

    `;

  }

}

customElements.define('ticketshop-footer', TicketshopFooter);
